"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[54211],{

/***/ 854211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SubSection": function() { return /* binding */ SubSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(816519);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(675601);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(428247);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  flex-grow: 1;\n  -webkit-box-align: center;\n  -webkit-box-flex: 1;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





const LIMIT_SUB_SECTION_BRANDS = 16;
const SubSection = (param)=>{
    let { subsections  } = param;
    const { isMobile  } = (0,hooks__WEBPACK_IMPORTED_MODULE_1__/* .useTenantConfig */ .Wx)();
    const brands = subsections.filter((param)=>{
        let { type  } = param;
        return type === "IMAGES";
    });
    const others = subsections.filter((param)=>{
        let { type  } = param;
        return type === "IMAGES_AND_TEXT";
    });
    const renderSuggestionBrands = ()=>{
        if (!brands || brands.length === 0 || brands.every((brand)=>{
            var ref;
            return !((ref = brand.items) === null || ref === void 0 ? void 0 : ref.length);
        })) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: brands.map((block, index)=>{
                var ref;
                if (!((ref = block.items) === null || ref === void 0 ? void 0 : ref.length)) {
                    return null;
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledFlex, {
                    gap: "s8",
                    flexWrap: isMobile ? "inherit" : "wrap",
                    paddingTop: "s8",
                    marginBottom: !others || others.length === 0 ? "s4" : "s12",
                    style: isMobile ? {
                        overflow: "scroll"
                    } : {},
                    children: block.items.slice(0, LIMIT_SUB_SECTION_BRANDS).map((brand, index)=>!!brand.thumbnailUrl && !!brand.linkUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, {
                            href: brand.linkUrl,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, _objectSpreadProps(_objectSpread({
                                padding: "s4",
                                width: 110,
                                variant: "default"
                            }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
                                isTrackContent: true,
                                regionName: "subSection",
                                contentName: JSON.stringify({
                                    block: "brand",
                                    item: brand.linkUrl
                                }),
                                target: brand.linkUrl
                            })), {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .LazyImage */ .w, {
                                    width: 100,
                                    height: "100%",
                                    src: brand.thumbnailUrl,
                                    contain: true
                                })
                            }))
                        }, "".concat(index).concat(brand.linkUrl)) : null)
                }, "".concat(index));
            })
        });
    };
    const renderOthersItem = (items, label)=>{
        return items.map((item, index)=>!!item.linkUrl && !!item.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, {
                href: item.linkUrl,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, _objectSpreadProps(_objectSpread({
                    direction: "column",
                    border: "1px solid border",
                    borderRadius: "s",
                    padding: "s4",
                    justify: "start",
                    align: "center",
                    width: 110,
                    height: isMobile ? 110 : 156
                }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
                    isTrackContent: true,
                    regionName: "subSection",
                    contentName: JSON.stringify({
                        block: label,
                        item: item.description
                    }),
                    target: item.linkUrl
                })), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .LazyImage */ .w, {
                            src: item.thumbnailUrl || "",
                            height: isMobile ? 56 : 90,
                            width: isMobile ? 56 : 90,
                            imageWidth: isMobile ? 112 : 180,
                            contain: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyleSubSectionWrapper, {
                            style: {
                                marginTop: "4px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledH2, {
                                isMobile: isMobile,
                                children: item.description
                            })
                        })
                    ]
                }))
            }, "".concat(index).concat(item.description)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}));
    };
    const renderOthers = ()=>{
        if (!others || others.length === 0) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: others.map((block, index)=>{
                const { title , items  } = block;
                const itemsPerView = isMobile ? 3.45 : 8;
                if (!(items === null || items === void 0 ? void 0 : items.length)) {
                    return null;
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Shape */ .b, {
                    marginBottom: "s4",
                    marginTop: "s12",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SubsectionHeader, {
                            isMobile: isMobile,
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledFlex, {
                            gap: "s8",
                            marginTop: "s8",
                            align: "center",
                            maxHeight: !items[0].thumbnailUrl ? 88 : 156,
                            flexWrap: isMobile ? "inherit" : "wrap",
                            style: {
                                overflow: isMobile ? "scroll" : "hidden"
                            },
                            children: !!items[0].thumbnailUrl ? // add navigation arrows only if number of display items >= length of data
                            items.length >= itemsPerView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledGlide, {
                                perView: itemsPerView,
                                breakpoints: {
                                    410: {
                                        perView: 3.35
                                    },
                                    390: {
                                        perView: 3.15
                                    },
                                    370: {
                                        perView: 2.95
                                    },
                                    350: {
                                        perView: 2.75
                                    }
                                },
                                type: "carousel",
                                showControl: true,
                                isMobile: isMobile,
                                children: renderOthersItem(items, title || "")
                            }) : renderOthersItem(items, title || "") : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: items.map((item, index)=>!!item.description && !!item.linkUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, {
                                        href: item.linkUrl,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, _objectSpreadProps(_objectSpread({
                                            padding: isMobile ? [
                                                "s0",
                                                "s12"
                                            ] : [
                                                "s0",
                                                "s20"
                                            ],
                                            width: isMobile ? "max-content" : "100%",
                                            variant: "default"
                                        }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
                                            isTrackContent: true,
                                            regionName: "subSection",
                                            contentName: JSON.stringify({
                                                block: title,
                                                item: item.description
                                            }),
                                            target: item.linkUrl
                                        })), {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSubTitle, {
                                                marginTop: "s4",
                                                weight: "regular",
                                                level: 4,
                                                line: 1,
                                                children: item.description
                                            })
                                        }))
                                    }, index) : null)
                            })
                        })
                    ]
                }, index);
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            renderSuggestionBrands(),
            renderOthers()
        ]
    });
};
const StyleSubSectionWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject());
const StyledSubTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .SubTitle */ .DK)(_templateObject1());
const StyledFlex = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k)(_templateObject2());
const SubsectionHeader = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].div((param)=>{
    let { isMobile  } = param;
    return "\n  margin: 0;\n  font-size: ".concat(isMobile ? "13px" : "18px", ";\n  line-height: 24px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n");
});
const StyledH2 = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].h2((param)=>{
    let { isMobile  } = param;
    return "\n  text-align: center;\n  font-weight: 400;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  ".concat(isMobile ? "\n  font-size: 12px;\n  line-height: 16px;" : "\n  flex-grow: 1;\n  -webkit-box-align: center;\n  -webkit-box-flex: 1;\n  align-items: center;\n  font-size: 13px;\n  line-height: 24px;", "\n");
});
const StyledGlide = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Glide */ .A)((param)=>{
    let { isMobile  } = param;
    return "\n  ".concat(isMobile ? ".glide__arrow--override {\n    visibility: visible;\n  }" : "", "\n");
});


/***/ })

}]);